import { ApiError } from "./ApiError";

export default class ForbiddenError extends ApiError {
  code = 403;
}
